module.exports = __webpack_public_path__ + "static/media/kolorowanka_6.ef0a7a9a.png";